export default "__VITE_ASSET__mAmL$Psk__"